module.exports = __webpack_public_path__ + "img/translationeditor_24.90409e1b.jpg";